import React from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { Image } from '@learningblocks/storybook-components';
import './style.scss';
import { SolutionTube } from '../../ProtocolComponents';
import { GlossaryProvider } from '../../GlossaryProvider';

export function MaterialCard(props) {
  const [open, setOpen] = React.useState(null);
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const toggleSlide = () => setOpen((slideOpen) => !slideOpen);

  const renderImage = () => {
    if (props.isSolutionTube) {
      return <div className='materialcard__imageBlock'>
        <SolutionTube
          isOpen={false}
          size={props.solutionTube.size}
          type={props.solutionTube.type}
          description={'props.description'}
          toggleOpen={() => { }}
          solution={
            {
              solutionColor: props.solutionTube.solutionColor,
              circleColor: props.solutionTube.circleColor,
              circleOutline: props.solutionTube.circleOutline,
              isOpen: false,
              label: props.solutionTube.label,
            }
          }
        />
      </div>

    }
    if (props.imageComponent) {
      return (
        <div className='materialcard__imageBlock'>{props.imageComponent}</div>
      );
    } else {
      return (
        <div id="materialcard__image" style={{ backgroundColor: '#003e6b', margin: 'auto', padding: 'auto' }}>
          <Image
            style={{ ...props.imageStyle }}
            src={props.image}
            alt={props.type}
            className='materialcard__image'
          />
        </div>
      );
    }
  };

  const { fullName, description, glossaryTitle } = props
  const content = glossaryTitle ? glossaryTitle : fullName;
  const MIN_DESCRIPTION_LENGTH = 0;
  const MAX_DESCRIPTION_LENGTH = 1000;

  let trancatedDescription;
  if (description.length > MAX_DESCRIPTION_LENGTH) {
    trancatedDescription = description.substring(
      MIN_DESCRIPTION_LENGTH,
      MAX_DESCRIPTION_LENGTH
    );
  }
  return (
    <div className='materialcard' onClick={toggleSlide}>
      {renderImage()}
      <div className='materialcard__titleblock'>
        <p className='materialcard__titleblock_text'>{parse(fullName)}</p>
      </div>
      <div className={`materialcard__slideblock ${(open !== null)?(open ? 'open' : 'closed'):null}`}>
        <p className='materialcard__slideblock_title'>{parse(fullName)}</p>
        {
          //((description.length) > MAX_DESCRIPTION_LENGTH) ?
            //<><p className='materialcard__slideblock_text'>{trancatedDescription+'...'}</p>
            <><p className='materialcard__slideblock_text'>{parse(description)}</p>
              <div style={{ lineHeight: 1.5, color: "#fff" }} onClick={() => { onOpenGlossary(props.contentID) }}>
                <p>Read more</p>
              </div>
            </>
            //:<p className='materialcard__slideblock_text'>{parse(description)}</p>
        }
      </div>
    </div>
  );
}

MaterialCard.propTypes = {
  /**
   * Url for image to be displayed on widget
   */
  image: PropTypes.string,
  /**
   * Title for the widget
   */
  title: PropTypes.string,
  /**
   * description for the widget
   */
  description: PropTypes.string,
  /**
   * React component to display instead of image [ Overrided image prop]
   */
  imageComponent: PropTypes.element || null,

  hassolutionTube: PropTypes.bool,

  solutionTube: PropTypes.any
};

MaterialCard.propTypes = {
  imageComponent: null,
};

export { Tube } from './Tube';
